export enum AdrClass {
  ADR_1 = 'adr-1',
  ADR_2_1 = 'adr-2-1',
  ADR_2_2 = 'adr-2-2',
  ADR_2_3 = 'adr-2-3',
  ADR_3 = 'adr-3',
  ADR_4_1 = 'adr-4-1',
  ADR_4_2 = 'adr-4-2',
  ADR_4_3 = 'adr-4-3',
  ADR_5_1 = 'adr-5-1',
  ADR_5_2 = 'adr-5-2',
  ADR_6_1 = 'adr-6-1',
  ADR_6_2 = 'adr-6-2',
  ADR_7 = 'adr-7',
  ADR_8 = 'adr-8',
  ADR_9 = 'adr-9',
}
